// Progress bar + level-progress block. ProgressBar is the reusable track/fill
// (also used by habit rows); LevelProgress is the composed level widget:
// level chip · title + hint · percent, over the bar.
// v33 — `ghost` a `marker` slúžia „kolám": ghost = kde bol používateľ v MINULOM kole v rovnakom
// bode obdobia (vyblednutá druhá výplň za aktuálnou), marker = méta na prekonanie (zvislá ryska).
// Obe sú v percentách tej istej stupnice ako `pct`; null/undefined = nevykreslí sa nič.
export function ProgressBar({ pct = 0, size = "md", fill, ghost = null, marker = null, className = "", style }) {
  const clamp = (v) => Math.max(0, Math.min(100, v));
  const p = clamp(pct);
  return (
    <div className={`bz-progress${size === "sm" ? " bz-progress--sm" : ""} ${className}`.trim()} style={style}>
      {ghost != null && <div className="bz-progress__ghost" style={{ width: `${clamp(ghost)}%` }} />}
      <div className="bz-progress__fill" style={{ width: `${p}%`, ...(fill ? { background: fill } : {}) }} />
      {marker != null && <div className="bz-progress__marker" style={{ left: `${clamp(marker)}%` }} />}
    </div>
  );
}

export function LevelProgress({ level, title, hint, pct = 0 }) {
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 14 }}>
        {level != null && <span className="bz-level__chip">{typeof level === "number" ? `Lv ${level}` : level}</span>}
        <div style={{ flex: 1, minWidth: 0 }}>
          {title && <div className="bz-h3">{title}</div>}
          {hint && <div className="bz-numeral" style={{ fontSize: 11.5, color: "var(--neutral-text-muted)", marginTop: 3 }}>{hint}</div>}
        </div>
        <span className="bz-numeral" style={{ fontSize: 13, color: "var(--brand-primary)" }}>{Math.round(pct)}%</span>
      </div>
      <ProgressBar pct={pct} />
    </div>
  );
}
